import { Theme } from "@mui/material/styles";

// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(17),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "28px",
    },
    heading2: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "28px",
    },
    boxBackground: {
      backgroundColor: "red",
    },
    rteLabel: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "18px",
    },
    paperBackgroundColor: {
      backgroundColor: "#f3f3f3",
    },
    CustomMuiDrawer: {
      "& .MuiDrawer-paper": {
        top: "64px",
        height: "calc(100% - 64px)",
      },
    },
    swipeableDrawer: {
      width: 300,
      marginTop: "80",
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    daysBlock: {
      paddingTop: "5px",
      float: "left",
      width: "300px",
    },
    dayItem: {
      maxWidth: "65px",
    },
    sampleLabel: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightRegular,
      color: "rgba(0, 0, 0, 0.54)",
      lineHeight: "18px",
    },
    marginBottom: {
      marginTop: "1px",
      fontSize: "13px !important",
    },
    Muilink: {
      textDecoration: "underline",
      color: "blue",
    },
    muiAlartRoot: {
      marginTop: "-25px",
      maxHeight: "100px",
      "& .MuiAlert-message": {
        //lineHeight: "1.5em",
        maxHeight: "5.5em",
        overflow: "hidden",
        padding: 0,
        // display: "flex",
        // justifyContent: "center",
        // alignItems: "center",
      },
      "& .MuiAlert-icon": {
        justifyContent: "center",
        alignItems: "center",
      },
    },
  })
);
